document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('.product-details-nav-item');
    const offset = 140; // 140 (if header is sticky) -- Adjust this value to control how far before the section you want to stop

    // Set the first link to be active by default
    if (links.length > 0) {
        links[0].classList.add('active');
    }

    links.forEach(link => {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            
            // Remove active class from all links
            links.forEach(link => link.classList.remove('active'));

            // Add active class to the clicked link
            this.classList.add('active');

            const targetClass = this.getAttribute('data-target-class');
            const targetElement = document.querySelector(`.${targetClass}`);

            if (targetElement) {
                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.scrollY - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
});
